import React, { useState } from 'react';
import { TextField, type TextFieldProps } from './TextField';
import { useDebouncedCallback } from '~/shared/hooks/useDebouncedCallback';

interface DebounceTextFieldProps extends TextFieldProps {
	debounceMs?: number;
}

export function DebounceTextField({ value, onChange, debounceMs = 500, ...props }: DebounceTextFieldProps) {
	const [localValue, setLocalValue] = useState(value ?? '');
	const [prevValue, setPrevValue] = useState(value);
	const debouncedOnChange = useDebouncedCallback((x: string) => onChange?.(x), debounceMs);

	if (value !== prevValue) {
		setPrevValue(value);
		setLocalValue(value ?? '');
	}

	const handleChange = (x: string) => {
		setLocalValue(x);
		debouncedOnChange(x);
	};

	return <TextField {...props} value={localValue} onChange={handleChange} />;
}
